import * as angular from 'angular';

import { ComponentDefinition } from '../../models';

class ModalController implements angular.IComponentController {
    readonly focus: string;
    readonly hideFooter: boolean;
    readonly modalCaptionNo: string;
    readonly modalCaptionYes: string;
    readonly modalId: string;
    readonly modalTitle: string;
    readonly noFunction: () => void;
    readonly onClose?: () => void;
    readonly onOpen?: () => void;
    readonly preventClose: boolean;
    readonly size: string;
    readonly yesDisabled: () => boolean;
    readonly yesFunction: () => void;

    static $inject = ['$timeout'];

    constructor(private _$timeout: angular.ITimeoutService) { }

    $onInit() {
        this._$timeout(() => {
            this.bindEvents();
        });
    }

    bindEvents() {
        this.bindOnOpen();
        this.bindOnClose();
        this.bindToClose();
    }

    bindOnOpen() {
        const el = angular.element(`#${this.modalId}`);
        const self = this;
        el.on('shown.bs.modal', () => {
            if (self.focus && self.modalId) {
                angular.element(`#${self.focus}`).focus();
            }
            if (self.onOpen) {
                self.onOpen();
            }
        });
    }

    bindOnClose() {
        angular.element(`#${this.modalId}`)
            .on('hidden.bs.modal', () => {
                if (this.onClose) {
                    this.onClose();
                }
            });
    }

    bindToClose() {
        $('.modal').on('click', function (event) {
            $(event.target).parent().modal('hide');
        });
    }

    cancel() {
        if (this.noFunction) {
            this.noFunction();
        }
    }
}

export const wtModal: ComponentDefinition = {
    componentId: 'wtModal',
    controller: ModalController,
    controllerAs: 'vm',
    template: require('./modal.component.html'),
    bindings: {
        focus: '@',
        hideFooter: '@',
        modalCaptionNo: '@',
        modalCaptionYes: '@',
        modalId: '@',
        modalTitle: '@',
        noFunction: '&?',
        onClose: '&?',
        onOpen: '&?',
        preventClose: '<',
        size: '@?',
        yesDisabled: '&?',
        yesFunction: '&',
    },
    transclude: {
        'footer': '?modalFooter'
    },
};